<template>
    <v-card :class="`dashboard jobrow elevation-3 mb-4 ${ job.status }`"  >
        <v-card-text>
            <v-row  justify="space-between" class="mb-2">
                <v-col cols="12" md="6" class="headline">
                    <span v-if="showLink(job)">
                        <router-link :to="{ name: 'check status report', params: { uuid: job.uuid, cid: job._id }}">
                            {{ label }}
                        </router-link>
                    </span>
                    <span v-else>{{ label }}</span>
                </v-col>
                <v-col cols="6" md="2" class="headline text-right" v-if="(reports_statusevents.reportConfig && reports_statusevents.reportConfig.showtype)" >
                    {{ job.type }}
                </v-col>
                <v-col class="text-right" cols="6" md="2" >
                    <v-icon v-if="job.status === 'inactive' " large color="gray ">{{ iconName('job_disabled') }}</v-icon>
                    <v-icon v-else-if="job.status === 'up'|| job.status === 'not running'" large color="green darken-2">{{ iconName('job_up') }}</v-icon>
                    <v-icon v-else large color="red darken-2">{{ iconName('job_down') }}</v-icon>
                </v-col>
            </v-row>
            <v-row v-if="reports_statusevents.reportConfig.showdescription && job.description && job.description.length" class='checkdescription'>
                {{ job.description }}
            </v-row>
            <template v-if="!reports_statusevents.reportConfig.hidecheckuptime">
                <v-divider class="mb-3"></v-divider>

                <v-row  v-if="job.status === 'inactive'">Check is currently disabled.</v-row>
                <v-row  v-else-if="job.status === 'not running'">Check is enabled but does not have any results yet.</v-row>
                <v-row  v-else-if="metric === 'Uptime for seven days'">
                    <v-col cols="12" md="12">
                        <v-row  justify="space-between">
                            <v-col class="s6 text-no-wrap" cols="12" md="1">
                                Date:
                                <br />Uptime:
                            </v-col>
                            <v-col class="s6 text-no-wrap" cols="12" md="1" v-for="(day) in sevenDays" v-bind:key="day">
                                <!-- {{idx}} {{day}} {{job.uptime[day]}} -->
                                {{ formatDay(day) }}
                                <br />
                                {{
                                    ((job.uptime && job.uptime[day] && job.uptime[day].uptime + "%") || "-" )
                                }}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row  v-else-if="metric === 'Uptime for seven and 30 days'">
                    <v-col cols="12" md="12">
                        <v-row  justify="space-between">
                            <v-col class="s6 text-no-wrap" cols="12" md="1">
                                Date:
                                <br />Uptime:
                            </v-col>
                            <v-col class="s6 text-no-wrap" cols="12" md="1" v-for="(day) in sevenDays" v-bind:key="day">
                                <!-- {{idx}} {{day}} {{job.uptime[day]}} -->
                                {{ formatDay(day) }}
                                <br />
                                {{
                                    ((job.uptime && job.uptime[day] && job.uptime[day].uptime + "%") || "-" )
                                }}
                            </v-col>
                            <v-col class="s6 text-no-wrap thirtydays" cols="12" md="1">
                                30 days
                                <br />
                                {{ ((job.uptime && job.uptime.total && job.uptime.total.uptime) ? job.uptime.total.uptime : 0 ) }}%
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row  v-else-if="metric === 'Current response time'">
                    <v-col cols="12" md="6" v-if="job.result && (job.result.rt || job.result.rt === 0)">
                        Current Response Time: {{ (job.result.rt) }} ms from {{  formatLocation(job.result.l) }}
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                        This check has no results yet.
                    </v-col>

                    <v-col cols="12" md="6" v-if="job.result && job.result.m && job.status === 'down'">{{ job.result.m }}</v-col>
                </v-row>

                <v-row  v-else>
                    <v-col cols="12" md="6">30 Day Uptime: {{ ((job.uptime && job.uptime.total && job.uptime.total.uptime) ? job.uptime.total.uptime : 0 ) }}%</v-col>
                    <v-col cols="12" md="6" v-if="now.date && job.uptime && job.uptime[now.date]" >
                        Today's Uptime: {{ (job.uptime[now.date].uptime) }}%
                    </v-col>
                </v-row>
            </template>

            <v-container v-if="showConfig && reports_statusevents.reportConfig && reports_statusevents.reportConfig.showConfig">
                <v-divider md12 class="mb-3 mt-3"></v-divider>

                <v-row class="md12" v-if="showCheckConfig === job._id"  >
                    <v-col md="12" cols="12">
                        <v-text-field name="checklabel" :value="(job.report && job.report.label) || ''" label="Custom Check Label" @input="setField($event, 'label', job)"></v-text-field>
                    </v-col>
                    <v-col md="12" cols="12">
                        <v-select :items="availablemetrics" label="Display metrics" :value="(job.report && job.report.displaymetric) || ''" @input="setField($event, 'displaymetric', job)" />
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-btn color="secondary" class="elevation-1" dark small @click="showCheckConfig = false, confirmRemoveCheck = false">
                            Cancel
                            <v-icon dark right>{{ iconName('cancel') }}</v-icon>
                        </v-btn>
                        <v-btn color="primary" class="elevation-1 ml-1" dark small @click="saveCheckConfig(job._id), showCheckConfig = false">
                            Save Change
                            <v-icon dark right>{{ iconName('save') }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row class="md12" v-else-if="confirmRemoveCheck === job._id"  >
                    <v-col md="12" cols="12">
                        <strong>Confirm Removal of  {{job._id}}</strong>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-btn color="secondary" class="elevation-1" dark small @click="showCheckConfig = false, confirmRemoveCheck = false">
                            Cancel
                            <v-icon dark right>{{ iconName('cancel') }}</v-icon>
                        </v-btn>
                        <v-btn color="warning" class="elevation-1 ml-1" dark small @click="removeCheck(job._id)">
                            Remove from Report
                            <v-icon dark right>{{ iconName('remove') }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row class="md12" v-else  justify="end" >
                    <v-btn color="primary" class="elevation-1" dark small @click="showCheckConfig = job._id, confirmRemoveCheck = false">
                        Edit
                        <v-icon dark right>{{ iconName('edit') }}</v-icon>
                    </v-btn>
                    <v-btn v-if="reports_statusevents.reportConfig && !reports_statusevents.reportConfig.includeallchecks" color="secondary" class="elevation-1 ml-1" dark small @click="confirmRemoveCheck = job._id, showCheckConfig = false">
                        Remove from Report
                        <v-icon dark right>{{ iconName('remove') }}</v-icon>
                    </v-btn>
                </v-row>

                <v-row v-if="showJobJSON === job._id"  @click="showJobJSON = false">
                    <pre>{{job}}</pre>
                </v-row>
                <v-row v-else >
                    <v-icon small @click="showJobJSON = job._id">{{ iconName('code') }}</v-icon>
                </v-row>

            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import appconfig from "../config/shared";
import { mapState } from "vuex";
import { format as date_format, parse as date_parse, subDays } from "date-fns";
import { formatDay } from "../lib/filter";
// import draggable from 'vuedraggable';

export default {
    name: "Reports_Statusevents_Checkstatus_Check",
    props: {
        showConfig: {
            type: Boolean,
            default: false
        },
        availablemetrics: {
            type: Array
        },
        jobprop: {
            type: Object
        }
    },
    data () {
        // console.log(this.jobprop);
        return {
            showCheckConfig: false,
            confirmRemoveCheck: false,
            showJobJSON: false,
            customCheckSettings: {},
            job:  {...this.jobprop}
        };
    },
    computed: {
        ...mapState(["currentUser", "checks", "reports_statusevents", "now"]),
        sevenDays: function () {
            if (!this.now) return;
            let days = [this.now.date];
            let dateobj = date_parse(this.now.date);
            for (let i = 1; i < 7; i++) {
                days.push(date_format(subDays(dateobj, i), "YYYY-MM-DD")); // we need this format to use the uptime data
            }
            return days;
        },
        label: function (  ) {
            // console.log('get Label', this.job);
            return (this.job.report && this.job.report.label) ||          // custom label set for the check on this report.
                    this.job.label ||                                // the job's label
                    this.job.params_target ||                        // this is how we get it from the server
                   (this.job.parameters && this.job.parameters.target) || // checks added locally before server refresh
                    this.job._id                                     // fallback, should always exist
            // console.log('getLabel from', job._id, (job.report && job.report.label), label);
            // return label
        },
        metric: function () {
            return (this.job.report && this.job.report.displaymetric) ||
                this.reports_statusevents.reportConfig.displaymetric
        }

    },
    methods: {
        // getLabel: function ( job ) {
        //     console.log('getLabel');
        //     return (job.report && job.report.label) ||          // custom label set for the check on this report.
        //             job.label ||                                // the job's label
        //             job.params_target ||                        // this is how we get it from the server
        //            (job.parameters && job.parameters.target) || // checks added locally before server refresh
        //             job._id                                     // fallback, should always exist
        //     // console.log('getLabel from', job._id, (job.report && job.report.label), label);
        //     // return label
        // },
        // getMetricType: function ( job ) {
        //     return (job.report && job.report.displaymetric) ||      // custom displaymetric set for the check on this report.
        //             this.reports_statusevents.reportConfig.displaymetric  // report setting.
        //     // console.log('getLabel from', job._id, (job.report && job.report.displaymetric), val);
        //     // return val
        // },
        removeCheck: function (val) {
            console.log('removeCheck', val);
            this.$store.dispatch('reports_statusevents/removeReportCheck', val);
        },
        saveCheckConfig: function (val) {
            console.log('saveCheckConfig', val, this.customCheckSettings[val]);
            const timestamp =  Date.now().toString(36);

            if (!this.customCheckSettings[val]) return;

            let record = {
                checkid: val,
                setCheck: Object.assign({ checkid: val }, this.customCheckSettings[val])
            };

            // for(let field in this.customCheckSettings[val]){
            //     console.log('saveCheckConfig setting', field, 'to', this.customCheckSettings[val][field]);
            //     this.job[field] = this.customCheckSettings[val][field];
            // }

            /*
                setCheck: {checkid: "201709282120FOZSE-LYOOZ87Y", label: "PUSH check test with no results!", order: 0}
            */

            this.$store.dispatch('setAlert', {message: "Saving check", key: timestamp, type: "info"})
            this.$store.dispatch('reports_statusevents/setReportCheck', record)
                .then( () => {
                    this.$store.dispatch('setAlert', {message: "Check Saved", key: timestamp, type: "success"})
                    this.$forceUpdate();
                })
                .catch( (e) => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Check Information", key: timestamp, type: "error"})
                    console.log("error saving config update");
                });
        },
        /**
         * This method sets local state only.  It does not dispatch to the store.
         * The check information is sent to the store when the user clicks save (calling saveCheckConfig).
        */
        setField: function (val, field, job) {
            // @TODO This is not setting the displaymetric for some reason.
            this.customCheckSettings[job._id] = this.customCheckSettings[job._id] || {};
            this.customCheckSettings[job._id][field] = val;
            console.log('setField', field, val, this.job)
            this.job.report[field] = val;
        },
        formatDay (val) {
            return formatDay(val, "D MMM");
        },
        /*
         * val should be the l field from a result record.
         */
        formatLocation (val) {
            let ts = 9999999999999;
            let loc;
            for (let k in val) {
                if (k < ts) loc = val[k];
            }
            return loc.toUpperCase();
        },
        iconName: function ( val ) {
            return appconfig.icons[val] || val;
        },
        showLink: function ( job ) {
            return this.reports_statusevents.reportConfig.showlinks && (this.reports_statusevents.reportConfig.showConfig || job.public);
        }
    },
    filters: {

    }
}
</script>

<style scoped>
    .jobrow.disable {
        border-left: 4px solid gray;
    }
    .jobrow.up {
        border-left: 4px solid #388E3C;
    }
    .jobrow.down {
        border-left: 4px solid #D32F2F;
    }
    .floatright {
        float: right;
    }
    .row {
        margin-left: 0;
        margin-right: 0;
    }
    .checkdescription {
        padding-left: 12px;
        padding-bottom: 12px;
        margin-top: -16px;
    }
</style>